import { Footer } from '@/components/elements/footer/footer.component';
import Navbar from '@/components/elements/navbar/navbar.component';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  topbar?: boolean;
  pageTitle?: React.ReactNode;
  children: React.ReactNode;
  onCancel?: () => void;
  onTailoring?: () => void;
  onNext?: () => void;
}

export const RootLayout = ({ children }: Props) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};
